import { render, staticRenderFns } from "./Pulmonology.vue?vue&type=template&id=e77081dc&scoped=true"
import script from "./Pulmonology.vue?vue&type=script&lang=js"
export * from "./Pulmonology.vue?vue&type=script&lang=js"
import style0 from "./Pulmonology.vue?vue&type=style&index=0&id=e77081dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77081dc",
  null
  
)

export default component.exports